module.exports = __webpack_public_path__ + "Flag-548.0de76db2bff2920d0d6be0814f19e158.svg";